<template>
    <div class="brand-index" @click="closePop">
       
    <!-- 品牌弹框 -->
   

    <!-- 品牌配件信息 -->
    <div class="brand-select-box" id="brand-select-box">
        <div class="brand-name" @click.stop="displayBrand">
            <div class="brand-select" >
                选择品牌 
                <i class="el-icon-arrow-down" v-if="!showBrand"></i>
                <i class="el-icon-arrow-up" v-if="showBrand"></i>
                </div>
            <div class="brand-checked" >{{oenaturebrand || "全部"}}</div>
        </div>
        <div class="brand-name">
            <div class="brand-select" @click.stop="displayProduct">
                产品分类 
                <i class="el-icon-arrow-down" v-if="!showProduct"></i>
                <i class="el-icon-arrow-up" v-if="showProduct"></i>
                </div>
            <div class="brand-checked" @click.stop="displayProduct">{{oesort || "全部"}}</div>
        </div>
        
        <!-- <div class="line"></div>
        <div @click="getList(3,'')" class="brand-names">
            <div class="brand-parts">配件数量</div>
            <div class="parts-text">{{goodsMsgTotal.total}}</div>
        </div>
        <div  @click="getList(3,'ok')" class="brand-names">
            <div class="brand-parts">有货</div>
            <div class="parts-text">{{goodsMsgTotal.in_total}}</div>
            
        </div>
        <div  @click="getList(3,'no')" class="brand-names">
            <div class="brand-parts">无货</div>
            <div class="parts-text">{{goodsMsgTotal.not_total}}</div>
            
        </div> -->
        <div class="close-btn" @click="clearBrand" v-if="(oenaturebrand || oesort)">
            清除
        </div>
        <div class="brand-search-outside" v-show="!showBrand"> 
            <el-input @click.stop.native="stopstop" v-model="result" clearable placeholder="请输入配件名称" @clear="onSearchClear" @keyup.enter.native="searchResult"></el-input>
            <div class="brand-btn" @click.stop="searchResult">搜索</div>
        </div>
    </div>

    <div class="brand-cls" v-if="showProduct" ref="productCategoryPopup">
        <div class="jiao"></div>
        <div class="brand-info">    
            <div class="cls-item" v-for="(cls,index) in clsList" :key="index" @click="toggleCategory(cls)" :class="{'active':oesort==cls}">
                {{index+1}} {{cls}}
            </div>
            
        </div>
    </div>

    <div class="brand-logo-list"   v-show="showBrand">
       
        <el-row :gutter="15">
            <el-col  v-for="(brand,i) in putList" :key="i"  :span="3">         
                <div class="img-box "  @click="getList(1,brand)" >
                    <img :src="require(`../../assets/brand/${brand}.png`)" alt="">
                </div>
            </el-col>
        </el-row>
        
    </div>
    <div class="nav-list" ref="targetElement"  :class="{'fiexd':scrollDistance>300}" :style="navObj">
        <!-- v-if="brand.showNav" -->
        <template v-for="(brand,index) in navList">
            <div   @click="toPath(brand.path)" :key="index" class="nav-item" >  {{ brand.title }}</div>
                
        </template>
    </div>


    <div v-show="!showBrand">
        <!-- v-loading="loading" -->
       <!-- 配件列表组件 -->
       <!-- 配件列表组件 -->
        <GoodsList 
            v-loading="loading"
            :total="Math.ceil(total)"
            :current-page="currentPage"
            :page-size="pageSize"
            :ac-sort="sortActive"
            :goods-list="partList"
            @sort="sortChange"
            @page-change="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
        />
    </div>
    
    
</div>

</template>

<script>
import GoodsList from '../../components/GoodsList.vue'
// let brandList = ["博世","采埃孚","法雷奥","索恩格","德尔福","伦福德",
//     "萨克斯","天合","卢卡斯","康迪泰克","车享配","汉高",
//     "汉格斯特","马瑞利","博格华纳","海拉","华诺威","斯泰必鲁斯","SABS",
//     "爱尔铃","ntk","天博","上海法雷奥","索菲玛","ati",
//     "华域三电","安庆帝伯格茨","三爱海陵","富奥","昌辉","信力",
//     "上海来利","崇芳","永信","捷豹","厦门理研","凯吉","征和","欧博萨","上海兴盛",
//     "一汽光洋","皮尔伯格","科尔本","石川岛","FTE","捷成唯科","森萨塔","上海制动器","马勒","华域汽车"
// ]
// "伦福德" 天合 "萨克斯",

let brandList = [
    "博世","采埃孚","卢卡斯","法雷奥","德尔福","索恩格","康迪泰克","马瑞利",
    "HNW","博格华纳","舍弗勒","海拉","马勒",
    "爱尔铃","NTK","FTE","ATI","上海来利","森萨塔","曲阜天博","上海法雷奥",
    "斯泰必鲁斯","上汽大众","一汽大众","永信","捷豹","车享配","石川岛","欧博萨","SCAEG","崇芳",
    "华域三电","安庆帝伯格茨","三爱海陵","富奥","昌辉","上海依工","信力",
    "皮尔博格","一汽光洋","科尔本施密特","中鼎","凯吉","征和","博世华域","松芝",
    "厦门理研","富临精工","岱高","三艾","伊顿",
]

export default {
    name:"brandIndex",
    components: {
        GoodsList
    },
    data(){
        return{
            goods_id:"",
            attrList:[],
            clsList:['电动','外设','分类'],
            sortActive:"",
            partList:[],
            gooodsHisList:[],
            hisVis:false,
            sort_type:"",
            sort_way:1,
            currentPage:1,
            total:0,
            oenaturebrand:"",
            oesort:"",
            pageSize:15,
            openAllotion:false,//货位详情
            goodsAllotion:{
                dy:{
                    title:"丹阳",
                    list:[]
                },
                sh:{
                    title:"上海",
                    list:[]
                }
            },
            goodsMsgTotal:{},
            msgPut:"收起品牌",
            putList:[],
            // showAll:false,
            storage_type:"",
            showZero:"",
            storeInfo:{},
            //    互换件相关
            storeVis:false,
            buyStoreList:[],
            showBrand:true,
            showProduct:false,
            result:"",
            aliasList:[],
            timer:null,//节流标识
            loading:false,
            searchText:"", // 添加搜索文本变量
            navList:[
                {
                title:"首页",
                path:"/index/navhome/self",
                showNav:true
                },
                {
                title:"找配件",
                path:"/find/index",
                showNav:true
                },
                {
                title:"品牌中心",
                path:"/brand",
                showNav:true
                },
                {
                title:"积分商城",
                path:"/integral",
                showNav:this.$store.state.is_int_show==0
                },
                {
                    title:"促销专区",
                    path:"/index/disgoods/1/all/71"
                },

                // {
                // title:"精准找件",
                // path:"",
                // showNav:true
                // },
                // {
                // title:"品牌宣讲",
                // path:"",
                // showNav:true
                // },
            ],
            
            navLeft:0,
			navObj:{},
            scrollDistance:0
        }
    },
    methods:{
        async openAll(data){  
            // 显示货位
            if(this.$store.state.member_id.indexOf('1780-')!=-1){ 
                let allotion = await this.$http(`${this.$axios.defaults.baseURL.replace("web",'public')}index.php?act=search&op=stockInfo`,{skuId:data.skuId})
                this.goodsAllotion = this.$hnwTools.getAllotion(allotion) 
            }  
            this.openAllotion= true
        },
        handleClose(done) {
            done();
        },
        displayBrand(){
            this.showBrand= !this.showBrand
            this.showProduct=false
        },
        displayProduct(){
            this.showProduct= !this.showProduct
            // this.showBrand=false
            // 页面加载完成后动态计算位置
            this.$nextTick(() => {
                this.calculateProductPopupPosition();
            });
        },
        // 动态计算产品分类弹出框位置
        calculateProductPopupPosition() {
            // if (this.showProduct && this.$refs.productCategoryPopup) {
            //     const productButton = document.querySelector('.brand-name:nth-child(2)'); // 产品分类按钮
            //     if (productButton) {
            //         const buttonRect = productButton.getBoundingClientRect();
            //         const popup = this.$refs.productCategoryPopup;
                    
            //         // 获取视窗尺寸
            //         const viewportWidth = window.innerWidth;
            //         const viewportHeight = window.innerHeight;
                    
            //         // 设置弹出框位置
            //         popup.style.position = 'absolute';
            //         popup.style.left = buttonRect.left + 'px';
            //         popup.style.top = buttonRect.bottom + 'px';
            //         popup.style.width = '570px';
                    
            //         // 确保弹出框不会超出右边界
            //         const popupRect = popup.getBoundingClientRect();
            //         if (popupRect.right > viewportWidth) {
            //             popup.style.left = (viewportWidth - popupRect.width - 10) + 'px';
            //         }
                    
            //         // 确保弹出框不会超出左边界
            //         if (popupRect.left < 0) {
            //             popup.style.left = '10px';
            //         }
            //     }
            // }
        },
        // 点版心区域 关闭品牌和产品选择的弹框
        closePop(){
            // this.showBrand=false
            this.showProduct=false
        },
        // 升序降序 - 支持两种调用方式：原有的(type, way, index)和组件的({field, order})
        sortChange(typeOrData, way, index) {
            let type, sortWay, sortIndex;
            console.log(typeOrData, way, index);
            
            if (typeof typeOrData === 'object') {
                // 组件调用方式 {field, order}
                type = typeOrData.field;
                sortWay = typeOrData.order
                
            } else {
                // 原有调用方式 (type, way, index)
                type = typeOrData;
                sortWay = way;
                sortIndex = index;
            }
            this.sort_type = type;
            this.sort_way = sortWay;
            console.log("this.sort_way",this.sort_way);
            
            this.sortActive = type + sortWay;

            
            console.log("this.sort_type",this.sortActive);
            this.getList()
        },
        
        getGoodsInfo(goods){
            goods.preRou = "品牌中心"
            localStorage.setItem("hnw-web-item-data",JSON.stringify(goods))
            this.$router.push("/brand/info")
            // if(this.$isCompany()){
            // }
        },
        toPath(path){
            if(path){
                this.$router.push(path)
            }
		},
        impueNumChange(goods) {

            if(isNaN(goods.goods_num)){
                this.$nextTick(()=>{
					this.$set(goods,"goods_num",1)
				})
            }
            // console.log("走1");
            
            if(goods.goods_storage!=0&&goods.goods_num>goods.goods_storage){
                this.$nextTick(()=>{
                    goods.goods_num = goods.goods_storage
                })
                return this.$store.commit('UpDateState',{invDia:true})
            }
        },
        impueNumChange(goods) {
          if (isNaN(goods.goods_num)) {
            this.$nextTick(() => {
              this.$set(goods, "goods_num", 1);
            });
          }else{
            console.log("goods.goods_storage",goods.goods_storage);
            
            if (goods.goods_storage > 0 && goods.goods_num > goods.goods_storage) {
              // 计算超出的数量
              const excessQuantity = goods.goods_num - goods.goods_storage;
              
              // 获取本地存储的数据
              let localPurData = localStorage.getItem('web-loca-pre-data');
              let purDataArray = [];
              
              // 解析已存在的数据
              if (localPurData) {
                try {
                  purDataArray = JSON.parse(localPurData);
                } catch (e) {
                  console.error('解析web-loca-pre-data失败:', e);
                  purDataArray = [];
                }
              }
              
              // 检查是否已存在相同商品（通过goods_id判断）
              const existingItemIndex = purDataArray.findIndex(item => item.goods_id === goods.goods_id);
              
              if (existingItemIndex === -1) {
                // 如果不存在相同商品，则添加新的商品信息
                const excessItem = {
                  ...goods,
                  goods_num: excessQuantity
                };
                purDataArray.push(excessItem);
                localStorage.setItem('web-loca-pre-data', JSON.stringify(purDataArray));
              }              
              this.$nextTick(() => {
                goods.goods_num = goods.goods_storage;
              });
              return this.$store.commit("UpDateState", { invDia: true });
            }          
          }
        },
        // 加入购物车
        joinCart(goods){ 
            if(!this.$isCompany()){
                return 
            }
            const tidySubPart = async ()=>{
                let cart = []
                let cartGoods = {}
                cartGoods.goods_num = goods.goods_num
                cartGoods.oecode = goods.oecode
                cartGoods.sccode = goods.sccode
                cartGoods.cart_type = 1
                // store_name
                let keys1 = ["goods_id","goods_name","goods_price","goods_storage","store_id","setlist_id"]
                keys1.forEach(key=>{
                    cartGoods[key] = goods[key]
                    // cartGoods.store_name = this.storeInfo.store_name
                })
                
                cart.push(cartGoods)
                // 跳转到加入成功页 
                let res = await this.$api.joinCart(cart)
            
                //更新记录中 已添加X件 字段
                if(res){

                    // 更新购物车数量
                    goods.cartNum = Number(goods.cartNum) + Number(goods.goods_num);
                    
                    // 初始化cartList数组，如果不存在则创建
                    if(!goods.cartList) {
                        goods.cartList = [];
                    }
                    
                    // 添加或更新购物车列表信息
                    const buyerName = this.$store.state.member_name || this.$store.state.nickname || '未知用户';
                    const existingCartItem = goods.cartList.find(
                        item => item.buyer_name === buyerName
                    );
                    console.log("existingCartItem",existingCartItem);
                    
                    if(existingCartItem) {
                        // 如果已存在该买家的信息，则更新数量
                        existingCartItem.goods_num = Number(existingCartItem.goods_num) + Number(goods.goods_num);
                    } else {
                        // 否则添加新的购物车项
                        goods.cartList.push({
                        buyer_name: buyerName,
                        goods_num: Number(goods.goods_num)
                        });
                    }
                
                }
            }
            console.log("走2");
            if(this.$store.state.zero_buy!=1){
                if(goods.goods_storage<1){
                    // return this.$store.commit('UpDateState',{invDia:true})
                }else if(goods.goods_num+Number(goods.cartNum)>goods.goods_storage){
                    return this.$store.commit('UpDateState',{invDia:true})
                }   
            }

            // 预购单已添加提示
            if(goods.goods_storage<1&&Number(goods.cartNum)>0){
                this.$affMsg("当前预购单已有该商品，是否继续添加?",tidySubPart)
            }else{
                tidySubPart()
            }

           
            
            
        },
        async replaceJoinCart(carItem){
            this.storeVis = false

            // if(this.$store.state.zero_buy!=1){
            //     if(carItem.goods_storage<1){
            //         return this.$store.commit('UpDateState',{invDia:true})
            //     }else if(carItem.goods_num+carItem.cartNum>carItem.goods_storage){
            //         return this.$store.commit('UpDateState',{invDia:true})
            //     }   
            // }

            let carMessage = {
                goods_id:carItem.goods_id,
                sccode:carItem.sccode,
                oecode:carItem.oecode,
                goods_name:carItem.goods_name,
                goods_price:carItem.goods_price,
                goods_storage:carItem.goods_storage,
                goods_num:carItem.goods_num,
                store_id:carItem.store_id,
                store_name:carItem.store_name,
                cart_type:'1'
            }
            
            await this.$api.joinCart([carMessage])
            
        },
        toSearch(goods){
     
            this.$store.commit("UpDateState", {
            searchText: goods.oecode
            });
            this.storeVis = false
            goods.replacePopVis = false
            this.$router.push("/find/index")
        },
        
        async showChangeParts(epcPart) {
            if(epcPart.exchange&&epcPart.exchange.length>0){
                let oem =  epcPart.exchange.join(",")
                this.buyStoreList = []
                let res = await this.$api.getBatchSearch({
                oem
                })
                console.log("epcPart",epcPart)
                console.log("res",res)
            
                if(res&&res.length>0){
                let addStr = ''
                res.forEach(goods=>{
                    if(!addStr.includes(goods.oecode)){
                    this.buyStoreList.push({
                        goods_id:goods.goods_id,
                        oecode:goods.oecode
                    })
                    addStr += goods.oecode+","
                    }
                })
                }
                epcPart.exchange.forEach(oecode=>{
                let has = this.buyStoreList.some(goods=>goods.oecode==oecode)
                if(!has){
                    this.buyStoreList.push({
                    oecode
                    })
                }
                
                })
                
                epcPart.replacePopVis = true
            }
        
        
        },
        async readHisList(goods_id){
            // this.$suMsg("请稍等")
            let res = await this.$api.getGoodsRecord(goods_id)
            this.gooodsHisList = res
            
            this.hisVis = true
        },
        changeZero(){
            
            this.getList(3,this.showZero?'ok':'')
        },
        clearBrand(){
            
            this.putList= brandList
            this.oenaturebrand = ""
            this.oesort=""
            this.result=""
            this.getList()
            this.showBrand = true
        },
        async getList(type,value){
            if (type==1&&!this.$store.state.member_id) {
                return this.$router.push("/login");
            }
            // this.storage_type = ""
            this.loading = true
            if(type==1){
                // 去掉数字 品牌
                this.oenaturebrand = value.replace(/\d/,'').replace("品牌",'')
                this.oesort = ""
                // this.putList = this.brandList.slice(0,8)
                this.showBrand = false
                this.currentPage = 1
                
            }else if(type==2){
                this.storage_type = ""
                // 如果传入的分类值为空，则清空分类筛选
                if (value === "") {
                    this.oesort = "";
                } else {
                    this.oesort = value;
                }
                this.showProduct=false
            }else if(type==3){
                this.currentPage = 1
                if(value=='ok'){
                    this.storage_type = 'gt'
                }else if(value=='no'){
                    this.storage_type = 'eq'
                }else{
                    this.storage_type = ""
                }
                // this.storage_type = value
            }else if(type==4){
                // 处理搜索请求，将value作为goods_name参数
                this.currentPage = 1;
                this.searchText = value; // 保存搜索文本
            }
            //  
            let sort_type  
            if(this.sort_type=='goods_storage'){
                sort_type = this.$store.state.is_sh=="0"?'goods_stcids':"goods_storage"
            }else{
                sort_type = this.sort_type
            }
            let  res = await this.$api.getBrandGoodsListNew({
                sort_key:sort_type||"goods_name",
                sort_value:this.sort_way==1?'ASC':'DESC',
                page:this.currentPage,
                limit:this.pageSize,
                shop_id:this.$store.state.shop, 
                store_id:this.$store.state.store_id,
                member_id:this.$store.state.member_id,
                stock:this.storage_type,
                oesort:this.oesort,
                search:this.oenaturebrand,
                goods_name: this.result 
            })
            this.loading = false
            // console.log("resCang",resCang)

    //         let res = await this.$api.getBrandGoodsList({
    //             store_id:this.$store.state.store_id,
    //             member_id:this.$store.state.member_id,
    //             curpage:this.currentPage,
    //             page:this.pageSize,
    //             sort_type:this.sort_type,
    //             sort_way:this.sort_way,
    //             oenaturebrand:this.oenaturebrand,
    //             oesort:this.oesort,
    //             storage_type:this.storage_type,
    //             shop_type:this.$store.state.shop_type
    //         }) 
            // if(type==1){
            //     // let code = this.$store.state.is_sh==1?'上海仓':"丹阳仓"

            //     if(res.data.length==0){
            //         let brandAlis =  this.aliasList.find(item=>item.brand==this.oenaturebrand)
            //         if(brandAlis){
            //             console.log("当前品牌存在别名",brandAlis);
            //             if(brandAlis.like_name.split(",")[0]){
            //                 this.oenaturebrand = brandAlis.like_name.split(",")[0]
            //                 res = await this.$api.getBrandGoodsListNew({
            //                     sort_key:this.sort_type,
            //                     sort_value:this.sort_way==1?'ASC':'DESC',
            //                     page:this.currentPage,
            //                     limit:this.pageSize,
            //                     shop_id:this.$store.state.shop, 
            //                     store_id:this.$store.state.store_id,
            //                     member_id:this.$store.state.member_id,
            //                     stock:this.storage_type,
            //                     oesort:this.oesort,
            //                     search:this.oenaturebrand
            //                 })
            //         //         res = await this.$api.getBrandGoodsList({
            //         //             store_id:this.$store.state.store_id,
            //         //             member_id:this.$store.state.member_id,
            //         //             curpage:this.currentPage,
            //         //             page:this.pageSize,
            //         //             sort_type:this.sort_type,
            //         //             sort_way:this.sort_way,
            //         //             oenaturebrand:this.oenaturebrand,
            //         //             oesort:this.oesort,
            //         //             storage_type:this.storage_type,
            //         //             shop_type:this.$store.state.shop_type,
            //         //             // code,
            //         //         })
            //             }

            //         }else{
            //             console.log("未找到对应品牌别名");
            //         }
            //     }
            // }
            if(res.class){
                this.clsList = res.class.filter(oe=>oe)
            }else{
                this.clsList = []
            }
            this.partList = res.data  
            if(this.$store.state.shop==1780){
                // this.partList = this.partList.filter(item => item.house_info!=null)
                let indexRes = []
                this.partList.forEach(goods=>{ 
                    // this.$set(goods,"cangTip","")
                    this.$storageCangInfo(goods)
                })
            } 
            if(res.stock){
                if(this.storage_type=='gt'){
                    this.total = res.stock.in_total
                }else if(this.storage_type=='eq'){
                    this.total = res.stock.not_total
                }else{
                    this.total = res.stock.total
                }
                this.goodsMsgTotal = res.stock
            }  
            this.partList.forEach(goods=>{
                this.$set(goods,"choose",false)
                this.$set(goods,"goods_num",1)
                // 对电商价格处理 
                
              
                goods.goods_price = this.$handlePrice(goods)
                console.log(goods,goods.final_delivery_time);
                
                 // 设置整箱单价
                if(this.$store.state.ratioBrandList){
                    let obj = this.$store.state.ratioBrandList.find(brand=>{
                        if(brand.name==goods.oenaturebrand){
                            return brand
                        }
                    })
                    if(obj){
                        if(goods.spec){
                            let box = goods.spec.split("/")
                            // console.log("intact",box);
                            if(box[1]){
                                this.$set(goods,"boxNum",box[0])
                                goods.brand_ratio_price = this.$hnwTools.times(goods.goods_price,obj.ratio)
                            }
                        }
                    }
                }

                if(!goods.cartNum){
                    goods.cartNum = 0
                }else{
                   
                  
                }
                if(goods.exchange){
                    goods.exchange = goods.exchange.filter(item=>item!=goods.oecode)
                    this.$set(goods,"replacePopVis",false)
                }else{
                    goods.exchange = []
                }
                this.$set(goods,"goodsorderInfo",'')
                if(!Array.isArray(goods.orderInfo)){
                    goods.goodsorderInfo = '1'
                }

            })
            
        },

        // 产品分类的搜索
        searchResult(){
            // 修改为调用getList接口，将result作为goods_name参数传递
            this.getList(4, this.result);
            this.showProduct = false
        },
        
        // 清空搜索框时触发搜索
        onSearchClear(){
            // 延迟执行搜索，确保清空操作完成
            this.$nextTick(() => {
                this.searchResult();
            });
        },
        
        // 切换分类选中状态
        toggleCategory(category){
            // 如果点击的是已选中的分类，则取消选中
            if (this.oesort === category) {
                this.oesort = "";
                this.storage_type = "";
                this.showProduct = false;
                this.currentPage = 1;
                this.getList(); // 重新加载数据，不带分类筛选
            } else {
                // 否则选中该分类
                this.getList(2, category);
            }
        },
        
        //  分页
        async handleSizeChange(val) {
            this.pageSize = val;
            this.currentPage = 1;
            await this.getList()
            
            scrollTo(0,0)
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getList()
        },

        handleScroll() {
			// 获取当前的滚动距离
			this.scrollDistance =  document.documentElement.scrollTop;
			if(this.scrollDistance>300){

				this.navObj.left = this.navLeft + "px"
			}else{
				try {
					const fixedElement = document.getElementById('brand-select-box');
					const rect = fixedElement.getBoundingClientRect();
					const leftDistanceToDocument = rect.left + window.pageXOffset;
					this.navLeft = leftDistanceToDocument - 140
					this.navObj = {}
				} catch (error) {
					
				}
			}
		},
		handleResize() {
			try {
				const fixedElement = document.getElementById('brand-select-box');
				const rect = fixedElement.getBoundingClientRect();
				const leftDistanceToDocument = rect.left + window.pageXOffset;
				this.navLeft = leftDistanceToDocument - 140
			} catch (error) {
				
			}
		},
        // 点击收起品牌
        // showPut(){
        //     // this.brandList.splice(0,32)
        //     // this.msgPut="展开品牌"
        //     if(this.showAll){
        //         this.putList=this.brandList
        //         this.msgPut="收起品牌"
                
        //     }else {
        //         // this.brandList=this.putList
        //          this.msgPut="展开品牌"
        //          this.putList = this.brandList.slice(0,8)
        //         //  console.log(this.putList);
        //     }
        //     this.showAll=!this.showAll
        // }
        observeVisibility() {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                if (entry.isIntersecting) {
                    // console.log('元素现在是可见的');
                    // 在这里可以执行你想要的操作
                    this.navObj = {}
                } else {
                    // console.log('元素现在是不可见的');
                    this.navObj = {}
                }
                });
            });

            // 开始观察挂载到this.$refs.targetElement上的元素
            observer.observe(this.$refs.targetElement);
        }
    },
    watch:{
    //   result(n){
    //       if(n==""){
    //           this.getList()
    //       }else{
    //           this.clsList= this.clsList.filter(item=> {
    //                  return item.includes(this.result)
    //              })
    //       }
    //   },
      showBrand(n){
        if(this.$store.getters.onlyBrand&&n==false){
            this.showBrand = true 
        }
      },
      
    },
    mounted() {
		// 添加滚动事件监听器
		window.addEventListener('scroll', this.handleScroll);
		window.addEventListener('resize', this.handleResize);
		// 如果你想要得到元素左边相对于整个文档（而不仅仅是当前视口）的距离，
		// 你需要加上当前的滚动偏移量
		// 定义一个函数来处理页面的可见性变化
        this.observeVisibility();
        // 添加窗口大小改变事件监听器，用于重新计算产品分类弹出框位置
        window.addEventListener('resize', this.calculateProductPopupPosition);
	},
	onBeforeUnmount(){
		window.removeEventListener('scroll', this.handleScroll);
		window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('resize', this.calculateProductPopupPosition);
	},
    async created(){
        
        // 首页防直营
        if(this.$store.state.for_branch&&this.$store.state.for_branch!=1780){
            this.$store.dispatch("getThan")
            this.$router.push(`/store/businesses/${this.$store.state.for_branch}`)
        }else if(this.$store.state.shop&&this.$store.state.shop!=1780){ 
            this.$store.dispatch("getThan")
            this.$router.push(`/store/businesses/${this.$store.state.shop}`)
        }

        // "产地","性质",
        let attr = ["OE号","商品名称","生产编码","配件品牌","库存","订货价"]
        document.title = '华诺威_汽配供应链专家';
        attr.forEach(title=>{
            let atrObj = this.$hnwTools.goodsAttrs.find(item=>item.title==title)
            if(atrObj){
                if(title=='OE号'){
                    atrObj.method = "getGoodsInfo"
                    
                }
                this.attrList.push(atrObj)
            }
        }) 
        // this.putList= JSON.parse(JSON.stringify(this.brandList))
        
        // 获取从epc跳过来的品牌 
        let activeBrand = localStorage.getItem("epc-brand-text")
       console.log(activeBrand);
       
       

        if(this.$store.state.exBrands&&this.$store.state.exBrands.length>1){
           brandList = brandList.filter(item=>!this.$store.state.exBrands.includes(item))
        }

        if(activeBrand){
            this.getList(1,activeBrand)
        }else{
            this.getList()
        }
        this.putList = brandList
    },
    updated() {
        // 在组件更新后重新计算产品分类弹出框位置
        if (this.showProduct) {
            this.$nextTick(() => {
                this.calculateProductPopupPosition();
            });
        }
    },
    destroyed(){
        localStorage.removeItem("epc-brand-text")
    }
}
</script>

<style lang="scss" scoped>
.brand-index{
    width: 1200px;
    margin: 0 auto;
    position: relative;
    padding-top: 10px;
    // position: relative;
    
     .put{
            height: 20px;
            // position: relative;
              text-align: center;
              line-height: 20px;
          .jiantou{
            //   margin-top: 10px;
            cursor: pointer;
          }
        }
    .brand-logo-list{
        padding-top: 10px;
        padding-bottom: 20px;
        position: relative;
        .el-col{
            margin-top: 15px;
        }
        .img-box{
            text-align: center;
            cursor: pointer;
            overflow: hidden;
            width: 136px;
            height: 136px;
            box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08);
            border-radius: 10px;
            img{
               width: 136px;
            }
        }
        .img-box:hover{
            transform: scale(1.1);
        }
    }
    .nav-list{
        width: 110px;
        align-self: flex-start;
        left: -140px;
        position: absolute;
        transition: top 0.3s ease;
        // top: 20px;
        top: 188px;
        .nav-item{
            background-color: #fff;
            width: 110px;
            height: 48px;
            text-align: center;
            box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.04);
            border-radius: 20px;
            border-bottom: 1px solid  #F2F2F2;
            background: #f1f1f1;
            cursor: pointer;
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;
            margin-bottom: 10px;
            i{
                margin-bottom: 2px;
            }
        }
        .active{
            
            background: #063376;
            border-radius: 20px;
            color: #fff;
        }
        .nav-item:hover{
            // width: 130px;
            
            background: #063376;
            border-radius: 20px;
            color: #fff;
        }
    }
    .fiexd{
        // background: #f00;
        position: fixed;
        top: 20px;
    }
    
    .brand-limit-list{
        justify-content: left;
        width: auto;
        .img-box{
            margin-right: 10px;
        }
    }
    .brand-select-box{
        // height: 77px;
        height: 154px;
        background: url("../../assets/new/brand/顶部.png");
        position: relative;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        color: #fff;
        .brand-name{
            margin-left: 45px;
            text-align: center;
            .brand-select{
                // padding: 19px 0 10px;
                cursor: pointer;
                font-family: Source Han Sans CN;
                font-weight: 500;
                font-size: 20px;
                color: #333333;
                padding-bottom: 8px;
            }
           
            .brand-checked{
                
                color: #50A3F8;
                text-align: center;
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 14px;
                color: #666666;
                // margin-left: 34px;
                width: 97px;
                height: 24px;
                line-height: 24px;
                border-radius: 10px;
                border: 1px solid #666666;
            }
           
        }
        .line{
            margin-top: 28px;
            width: 114px;
            height: 27px;
            opacity: 0.2;
            padding: 0;
            // margin-right: 20px;
        }
        .brand-names{
            width: 95px;
            text-align: center;
            .brand-parts{
                font-family: Source Han Sans CN;
                font-weight: 400;
                font-size: 20px;
                color: #333333;
            }
           .parts-text{
            font-family: MiSans;
            padding-top: 8px;
            font-weight: 800;
            font-size: 20px;
            color: #002F7B;
           }
        }
        // >div{
        //     padding: 0 10px;
        //     cursor: pointer;
        // }
        >div:first-child{
            cursor: default;
        }
        .close-btn{
            cursor: pointer;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 320px;
            margin-left: 10px;
            width: 54px;
            height: 30px;
            line-height: 29px;
            text-align: center;
            background: #FFFFFF;
            border-radius: 6px;
            font-size: 14px;
            font-weight: bold;
            color: #50A3F8;
        }
        .brand-search-outside{
            display: flex;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 400px;
            .el-input{
                ::v-deep .el-input__inner{
                    height: 32px;
                    line-height: 32px;
                    border: 1px solid #498FFF;
                    border-radius: 2px 0 0 2px;
                }
            }
            .brand-btn{
                width: 74px;
                height: 30px;
                font-size: 14px;
                color: #fff;
                text-align: center;
                line-height: 30px;
                background: #498FFF;
                cursor: pointer;
                border: 1px solid #498FFF;
                border-radius: 0 2px 2px 0;
            }
        }
    }
    .brand-cls{
        z-index: 999;
        // height: 214px;
        width: 570px;
        // overflow-y: auto;
        border: 1px solid #ccc;
        padding: 20px;
        position: absolute;
        left: 130px;
        top: 125px;
        background-color: #fff;
        // display: flex;
        // flex-wrap: wrap;
        // align-items: center;
        .jiao{
            position: absolute;
            top: -8px;
            left: 116px;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 4px 8px 4px;
            border-color: transparent transparent #fff transparent;
        }
        .brand-search{
            display: flex;
            .el-input{
                ::v-deep .el-input__inner{
                    height: 32px;
                    line-height: 32px;
                    border: 1px solid #498FFF;
                    border-radius: 2px 0 0 2px;
                }
            }
            .brand-btn{
                width: 74px;
                height: 30px;
                font-size: 14px;
                color: #fff;
                text-align: center;
                line-height: 30px;
                background: #498FFF;
                cursor: pointer;
                border: 1px solid #498FFF;
                border-radius: 0 2px 2px 0;
            }
        }
        .brand-info{
            margin-top: 5px;
            display: flex;
            flex-wrap: wrap;
            .cls-item{
                margin: 0 10px;
                padding: 5px 0;
                cursor: pointer;
                // width: 98px;
            }
            .active{
                color: #3E84D6;
            }
        }
    }
    // 该品牌下的分类
    .goods-list{
       box-shadow: 0px 0px 13px 0px rgba(0, 0, 0, 0.13);
       min-height: 190px;
       .goods-spec{
        min-width: 80px;
        max-width: 80px;
        text-align: center;
       }
       .sccode{
        min-width: 180px;
        max-width: 180px;
       }
       .goods_storage{
        min-width: 100px;
        max-width: 100px;
       }
       .goods_price{
        min-width: 80px;
        max-width: 80px;
       }
        .list-head{
            display: flex;
            height: 40px;
            align-items: center;
            background: #C4C9CC;
            margin: 10px 0 0 0;
            .head-item{
                flex: 1;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                .filterZero{
                    position: absolute;
                    top: 15px;
                   
                }
                .sort{
                    // display: flex;
                    // flex-direction: column;
                    // justify-content: center;
                    // margin-left: 2px;
                     width: 12px;
                    height: 12px;
                    img{
                      width: 12px;
                    height: 12px;  
                    }
                }
                i{
                    cursor: pointer;
                    font-size: 12px;
                }
                i:hover{
                    transform: scale(1.5);
                    color: #3E84D6;
                }
                .el-icon-caret-top{
                    position: relative;
                    top: 2px;
                }
                .el-icon-caret-bottom{
                    position: relative;
                    top: -2px;
                }
                .active{
                    color: #3E84D6;
                }
            }
            
            .oecode{
                // min-width: 180px;
                min-width: 200px;
                
            }
            .goods_name{
                min-width: 160px;
                max-width: 160px;
            }
            .buy-nums{
                max-width: 120px;
                min-width: 120px;

            }
            .handle{
                min-width: 140px;
                max-width: 140px;
                line-height: 22px;
            }
        }
        .list-body{
            // border-top: 1px solid #9E9E9E;
            .list-goods{
                // padding: 15px 0;
                
                position: relative;
                // border-bottom: 1px solid #CCCCCC;
                
                .row{
                    display: flex;
                    // height: 72px;
                    // padding-bottom: 10px;
                    .display-center{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                    }
                    .list-rol{
                        flex: 1;
                        text-align: center;
                        // line-height: 72px;
                        // height: 72px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        border-right: 1px solid  #E3E4EA;
                        position: relative;
                        .watermark-text{
                            
                            left: 18%;
                            
                            top: 18%;
                        }
                        .hnw-copy{
                            position: absolute;
                            right: 20px;
                            top: 8px;
                        }
                        .id-bs{
                            position: absolute;
                            left: 50%;
                            bottom: 10%;
                            color: #ccc;
                            // border: 1px solid #efefef;
                            border-radius: 50%;
                            width: 70px;
                            text-align: center;
                            transform: translateX(-50%);
                            .bordiv{
                                position: absolute;
                                left: 0;
                                bottom: -2px;
                                width: 100%;
                                height: 100%;
                                transform: scale(1.3);
                                border-radius: 50%;
                                border: 2px solid #efefef;
                            }
                            .bordiv1{
                                position: absolute;
                                left: 0;
                                bottom: -2px;
                                width: 100%;
                                height: 100%;
                                transform: scale(1.1);
                                border-radius: 50%;
                                border: .5px solid #efefef;
                            }
                        }
                        .blue{
                            color: #3E84D6;
                        }
                        .vehicle{
                            width: 180px;
                            height: 38px;
                            position: absolute;
                            bottom: 0;
                            left: 10px;
                            overflow: hidden;
                            text-align: left;
                            color: #999999;
                            font-style: 12px;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                        }
                        .goods-storage{
                            // line-height: 0;
                            // margin-top: -18px;
                            font-size: 12px;
                            color: red;
                            font-weight: bold;
                        }
                    }
                    
                    .oecode{
                        // min-width: 180px;
                        line-height: 58px;
                        min-width: 200px;
                        display: flex;
                        box-sizing: border-box;
                        // padding-left: 15px;
                        align-items: center;
                        cursor: pointer;
                        .brand{
                            min-width: 48px;
                            max-width: 48px;
                            height: 20px;
                            margin: 0 10px;
                            background: #3E84D6;
                            text-align: center;
                            line-height: 20px;
                            color: #fff;
                        }
                        .tag-icon{
                            display: flex;
                            align-items: center;
                            transform: scale(.7);
                            justify-content: center;
                            width: 20px;
                            height: 20px;
                            background: $vin-blue;
                            color: #fff;
                            // border: 1px solid $vin-blue;
                            border-radius: 50%;
                            font-size: 12px;
                            position: relative;
                            top: -5px;
                            left: 2px;
                        }
                    }
                    .goods_name{
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        min-width: 160px;
                        max-width: 160px;
                    }
                    .buy-nums{
                        min-width: 120px;
                        max-width: 120px;
                        position: relative;
                        .el-input-number{
                            width: 110px;
                        }
                        .goods-Fcl-tit{
                            position: absolute;
                            left: 50%;
                            transform: translateX(-50%);
                            bottom: 2px;
                            font-size: 12px;
                            line-height: 12px;
                            width: 120px;
                            text-align: center;
                            color: #999;
                        }
                    }
                    .handle{
                        line-height: 16px;
                        min-width: 140px;
                        max-width: 140px;
                        justify-content: center;
                        flex-wrap: wrap;
                        align-items: center;
                        padding-top: 5px;
                        padding-left: 10px;
                        box-sizing: border-box;
                        >div{
                            margin-top: 2px;
                        }
                        .btn{
                            width: 80px;
                            height: 22px;
                            display: flex;
                            justify-content: center;
                            border:1px solid #3E84D6;
                            color: #3E84D6;
                            align-items: center;
                            border-radius: 5;
                            cursor: pointer;
                            &:active{ 
                                transform: scale(1.1);
                            }
                        } 
                        .cart-num{
                            width: 80px;
                            height: 16px;
                            
                            font-size: 12px;
                            color: #999999;
                            
                        }
                        .replace-btn{
                            width: 80px;
                            height: 16px;
                            color: #59A8F8;
                            text-align: center;
                            cursor: pointer;
                        }
                    }
                    
                }
                .row-two{
                    border-top: 1px solid #E3E4EA;;
                    height: 31px;
                    padding-bottom: 0px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    >div{
                        color: #999999;
                    }
                   
                    .buyHis{
                        // font-style: italic;
                        cursor: pointer;
                        text-align: right;
                        flex: 1;
                        padding: 0 5px;
                      
                        color: red;
                        // color: #999;
                        
                        >span{
                            margin-right: 20px;
                            align-items: center;
                        }
                        .readMore{
                            cursor: pointer;
                        }
                    }
                    .han-box{
                        display: flex;
                        
                        text-align: center;
                        .col-num{
                            min-width: 120px;
                            
                        }
                        .handle{
                            flex: 1;
                            flex-direction: column;
                            min-width: 100px;
                            max-width: 100px;
                            line-height: 22px;
                            position: relative;
                            >div{
                                left: 10px;
                            }
                            .cart-num{
                                position: absolute;
                                top: -10px;
                            }
                            .replace-btn{
                                color: #3E84D6;
                                cursor: pointer;
                                position: absolute;
                                bottom: -10px;

                            }
                        }
                    }
                }
            }
            .list-goods:nth-child(2n){
                background: #f7f7f7;
            }
            
        }
    }
    .el-dialog__body{
        // padding: 10px 20px;
        padding: 0 !important;
        .his-list{
            .list-head{
                display: flex;
                height: 40px;
                align-items: center;
                background: #EEEEEE;
                margin: 10px 0;
                padding: 0 8px;
                >div{
                    flex: 1;
                    text-align: center;
                }
                .col-100{
                    max-width: 100px;
                }
            }
            .list-body{
                .row{
                    display: flex;
                    padding: 0 8px;
                    >div{
                        flex: 1;
                        padding: 2px 0;
                        border-bottom: 1px solid #eee;
                        flex: 1;
                        text-align: center;
                        line-height: 28px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                    .col-100{
                        max-width: 100px;
                    }
                }
            }
        }
    }
    // 互换件
    .store-vis {
        ::v-deep .el-dialog__header{
        padding: 0;
        }
        ::v-deep .el-dialog__body{
            padding: 0;
        }
        .el-dialog {
        .hhj-index{
            width: 40px;
        }
        .handle{
            width: 80px;
            text-align: center;
            .btn {
            cursor: pointer;
            color: #3E84D6;
            }
        }
        .oe{
            flex: 1;
            text-align: center;
        }
        .tit {
            padding: 10px;
            background: #3E84D6;
            color: #fff;
            display: flex;
            justify-content: space-between;
            .el-icon-close {
            cursor: pointer;
            color: #fff;
            }
        }
        
        .list-body {
            padding: 10px;
            .list-head {
            display: flex;
            background: #dfdfdf;
            height: 28px;
            line-height: 28px;
            
            
            }
            .list-row {
            display: flex;
            align-items: center;
            border-bottom: 1px solid#ccc;
            > div {
                text-align: center;
            
                padding: 8px 0;
                display: flex;
                justify-content: center;
                align-items: center;
                
            }
            }
        }
        }
    }
	.paging{
        margin-top: 45px;
        display: flex;
        justify-content:flex-end;
        margin: 15px 0;
        .database{
            line-height: 30px;
        }
    }

    .hezi{
        .el-dialog__wrapper{
            .el-dialog{
                width: 760px;
                .el-dialog__header{
                    position: relative;
                    padding: 10px 20px 20px;
                        .el-icon-close:before{
                            position: absolute;
                            top: -10px;
                            right: 0px;
                    }
                }
                .el-dialog__body {
                    overflow-y:auto;
                    height: 500px;
                    padding: 0 10px;
                    box-sizing: border-box;
                  
                }
            }
        }
    }
}
.alltion{
  width: 100%;
  display: flex; 
  align-items: center;
  height: 40px;
  border-bottom: 1px solid #eee;
  >div{
    width: 25%;
    text-align: center; 
  }
}
   </style>